<template>
  <div class="cell">
    <slot>
      <p>
        <span v-if="value" class="val">{{value}}</span>
        <span v-else>&nbsp;</span>
        <span class="rank" v-if="rank && showRank">{{rank}}{{ordinal(rank)}}</span>
      </p>
    </slot>
  </div>
</template>
<script>
export default {
  name: 'table-cell',
  data () {
    return {}
  },
  created: function () {},
  props: ['value', 'rank', 'showRank'],
  computed: {},
  methods: {
    ordinal: function (num) {
      let ending
      switch (num) {
        case 1:
          ending = "st"
          break;
        case 2:
          ending = "nd"
          break;
        case 3:
          ending = "rd"
          break;
        default:
          ending = "th"
          break;
      }
      return ending
    }
  }
}
</script>
<style src="./cell.styl" lang="stylus" scoped></style>
